import { useGetActiveLeadSource } from '@forwardflow/hooks/customHooks/campaign'
import CampaignService from '@forwardflow/services/CampaignService'
import { useCampaignActivationModalStore } from '@forwardflow/store/modal/campaignActivationModal'
import { usePhoneNumberUnavailableModalStore } from '@forwardflow/store/modal/phoneNumberUnavailableModal'
import { Button } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { message } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'

const TopBar = () => {
   const { openCampaignActivationModal } = useCampaignActivationModalStore()
   const [searchParams] = useSearchParams()
   const campaignName = searchParams.get('campaignName')
   const [isStatusChanging, setIsStatusChanging] = useState(false)
   const [isLoading, setIsLoading] = useState(false)
   const [isCampaignActive, setIsCampaignActive] = useState(false)
   const { title } = useParams()
   const { setUnavailablePhoneNumbers, openPhoneNumberUnavailableModal } =
      usePhoneNumberUnavailableModalStore()
   const { data: activeLeadSourceDetails, mutate } = useGetActiveLeadSource(
      title || ''
   )

   const [showSaveButton, setShowSaveButton] = useState(false)

   useEffect(() => {
      if (activeLeadSourceDetails) {
         setIsCampaignActive(activeLeadSourceDetails.status === 'active')

         setShowSaveButton(
            activeLeadSourceDetails?.draft?.changedSections?.length > 0
         )
      }
   }, [activeLeadSourceDetails])

   const onCampaignStatusChange = async () => {
      setIsStatusChanging(true)
      try {
         await CampaignService.updateCampaignStatus(
            title as string,
            isCampaignActive ? 'paused' : 'active'
         )
         message.success('Campaign status updated successfully')
         mutate()
      } catch (error) {
         console.log(error)
      } finally {
         setIsStatusChanging(false)
      }
   }

   const ApplyDraftCampaign = async () => {
      try {
         setIsLoading(true)

         const response = await CampaignService.applyDraftCampaign(
            title as string
         )
         if (response?.hasFailedPurchase) {
            const phoneNumberArray: string[] = []
            response?.purchaseResult?.failedPurchases.map((purchase: any) => {
               phoneNumberArray.push(purchase.phoneNumber)
            })
            setUnavailablePhoneNumbers(phoneNumberArray)
            openPhoneNumberUnavailableModal()
         } else {
            message.success('Draft campaign applied successfully')
         }
      } catch (error) {
         console.error('Error applying draft campaign:', error)
         message.error('Failed to apply draft campaign')
      } finally {
         setIsLoading(false)
         mutate()
      }
   }

   return (
      <>
         <div className="bg-white/5 h-[60px] rounded-lg flex items-center">
            <Link to="/campaign">
               <Button className="!w-[54px] h-[54px] border-transparent bg-transparent !rounded-lg !mt-0 ml-1 mr-5">
                  <Icon
                     name="arrow-right"
                     className="rotate-180 fill-white"
                     width={20}
                     height={20}
                  />
               </Button>
            </Link>

            <span className="text-[#717171] mr-auto">
               <Link to="/dashboard"> Home /</Link>
               <Link to="/campaign"> campaign /</Link>
               {title ? <span> {campaignName} /</span> : null}
               <span className="text-white"> Activate</span>
            </span>
            {showSaveButton &&
               activeLeadSourceDetails &&
               activeLeadSourceDetails?.status !== 'draft' && (
                  <>
                     <Button
                        isLoading={isLoading}
                        onClick={ApplyDraftCampaign}
                        className="max-w-[180px] mr-2 shrink-0 h-full !mt-0 !rounded-[4px] !bg-white/20 hover:!bg-white/30 !border-none"
                     >
                        Save Changes
                     </Button>
                  </>
               )}
            {activeLeadSourceDetails ? (
               activeLeadSourceDetails.status === 'draft' ? (
                  <Button
                     onClick={openCampaignActivationModal}
                     className="max-w-[230px]  h-full !mt-0 !rounded-[4px]"
                  >
                     Activate Campaign
                  </Button>
               ) : (
                  <Button
                     isLoading={isStatusChanging}
                     onClick={onCampaignStatusChange}
                     className="max-w-[230px]  h-full !mt-0 !rounded-[4px] flexc"
                  >
                     {activeLeadSourceDetails.status === 'active' ? (
                        <>
                           <Icon name="Pause" className="mr-2 fill-white" />
                           <p className="text-white">Pause</p>
                        </>
                     ) : (
                        <>
                           <Icon
                              name="Play"
                              className="mr-2 scale-75 fill-white"
                           />
                           <p className="text-white">Resume</p>
                        </>
                     )}
                  </Button>
               )
            ) : null}
         </div>
      </>
   )
}
export default TopBar
